// extracted by mini-css-extract-plugin
module.exports = {"container":"chartResult_container__1tMnw","heading":"chartResult_heading__3uD41","content":"chartResult_content__2oaxA","item":"chartResult_item__1RYj4"};